exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-feedback[data-v-cc9b5ef2] {\n  opacity: .5;\n}\n", ""]);

// exports
